// src/plugins/posthog.js
import posthog from "posthog-js"

export default {
    install(Vue) {
        posthog.init("phc_QrkRyLvTofrtBZjJfwGe9NsIUY0weg0ymHUoXMClCZS", {
            api_host: "https://eu.i.posthog.com",
            defaults: "2025-11-30",

            // 1. Keeps automatic recording off until you call startSessionRecording()
            disable_session_recording: true,

            // 2. Disables the "Event Tracking" side (clicks, inputs, pageviews)
            autocapture: false,
            capture_pageview: false,
            capture_pageleave: false,
        })

        Vue.prototype.$posthog = posthog
    },
}
